// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3ORjo","socialIco":"_13hNR"};